// extracted by mini-css-extract-plugin
export default {"signupbody":"signup_signupbody__pVJQH","signupform":"signup_signupform__aJZJ7"};